var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filters__range"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_setup.range[0])+" "+_vm._s(_vm.options.unit)+" - "+_vm._s(_setup.range[1])+" "+_vm._s(_vm.options.unit))]),_vm._v(" "),_c('div',{ref:"sliderElRef",staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }